import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type GetNumberModalStore } from 'entities/Phone/ui/GetNumberModal/store/GetNumberModalStore'
import styles from './styles.module.scss'

type IGetNumberModalActionsProps = {
  store: GetNumberModalStore
}

export const GetNumberModalActionsDefault: FC<IGetNumberModalActionsProps> = observer(
  ({ store }) => {
    const { loadingNumber, chooseNumberStore, handleAddNumberForChooseNumber, closeModal } = store
    const isUKComplianceRequired = chooseNumberStore.showUKComplianceBanner
    return (
      <div className={styles.actionsWrap} aria-label={getAriaLabel('GetNumberModalActions')}>
        {isUKComplianceRequired ? (
          <Button fullWidth typeBtn={'contained'} text={'Close'} onClick={closeModal} />
        ) : (
          <Button
            disabled={!chooseNumberStore.selectedNumber || loadingNumber}
            fullWidth
            typeBtn={'contained'}
            text={'Next'}
            onClick={() => {
              handleAddNumberForChooseNumber()
            }}
          />
        )}
        <Typography
          variant={'body-xs-regular'}
          color={'var(--content-primary-tertiary)'}
          className={styles.text}
          ariaLabel={'Aircall number'}
        >
          You can always change this number later or replace with your existing number, landline, or
          Aircall number.
        </Typography>
      </div>
    )
  }
)
